import { render } from "./SoundOutputPage.vue?vue&type=template&id=3ee69c82&scoped=true&ts=true"
import script from "./SoundOutputPage.vue?vue&type=script&lang=ts"
export * from "./SoundOutputPage.vue?vue&type=script&lang=ts"

import "./SoundOutputPage.vue?vue&type=style&index=0&id=3ee69c82&scoped=true&lang=css"

import exportComponent from "/builds/sensing-evolution/iframe-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee69c82"]])

export default __exports__